<template>
  <div class="search list-light texture-light-bg-css">
    <div>
      <div class="w search-input">
        <input
          :class="keyWord === '' ? 'input-css' : 'input-css active'"
          id="newTel"
          v-model="keyWord"
          type="text"
          placeholder="搜一下"
          autofocus="autofocus"
        />
        <div
          :class="
            searchClick
              ? 'search-btn cursor-pointer active'
              : 'search-btn cursor-pointer'
          "
          @click="searchFn"
        >
          <i class="iconfont icon-search"></i>
        </div>
      </div>
      <ul class="text-center w clearfix search-title">
        <li
          v-for="item in searchType"
          :key="item.value"
          :class="
            type === item.value
              ? 'search-title-list active'
              : 'search-title-list'
          "
          @click="tabFn(item.value)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="w">
      <div class="text-center" v-if="listData && listData.data.length !== 0">
        <div class="image-text-lists-total text-left cursor-default">
          为您查询到关于“<i class="search-key"> {{ listData.keyword }} </i>”
          共计{{ thousandsSeparator(listData.total) }}个相关内容
        </div>
        <ul class="text-center image-text-lists light-flower-bg">
          <li
            v-for="list in listData.data"
            :key="list.id"
            :class="
              list.ontop && list.ontop === 1 ? 'on-top relative' : 'relative'
            "
          >
            <i class="s-flower absolute"></i>
            <div
              v-if="
                list.image_url ||
                  list.thumbnail_url ||
                  list.image_url !== '' ||
                  list.thumbnail_url !== ''
              "
              class="image-text-img"
            >
              <img :src="list.image_url || list.thumbnail_url" />
            </div>
            <div
              :class="
                list.image_url ||
                list.thumbnail_url ||
                list.image_url !== '' ||
                list.thumbnail_url !== ''
                  ? 'image-text-content'
                  : 'image-text-content no-img'
              "
            >
              <div
                class="image-text-content-title cursor-pointer"
                v-html="replaceKeyWord(list.title, listData.keyword)"
                @click="listClickFn(list)"
              ></div>
              <MarkdownViewer
                class="image-text-content-info"
                :emptyText="''"
                :content="replaceKeyWord(list.description, listData.keyword)"
              ></MarkdownViewer>
              <div
                v-if="$refs.SearchJumpInfo.getCategory(list.category_id)"
                class="image-text-content-time"
              >
                来自<span
                  class="from"
                  @click.stop="
                    link(
                      $refs.SearchJumpInfo.getCategory(list.category_id),
                      'windowOpen'
                    )
                  "
                  >{{
                    $refs.SearchJumpInfo.getCategory(list.category_id).title ||
                      ''
                  }}</span
                >
              </div>
            </div>
          </li>
        </ul>
        <div class="pag text-center">
          <paginate
            class="clearfix deep-page"
            v-model="listData.page"
            :page-count="listData.pageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="''"
            :next-text="''"
            prev-class="page-prev"
            next-class="page-next"
            :container-class="'pagination'"
            :page-class="'page-item'"
          >
          </paginate>
        </div>
      </div>
      <div v-else class="text-center image-text-lists no-data">
        {{ errorMsg }}
      </div>
    </div>
    <SearchJumpInfo ref="SearchJumpInfo"></SearchJumpInfo>
  </div>
</template>

<script>
import dateFilter from '@/core/mixins/dateFilter'
import textFilter from '@/core/mixins/textFilter'
import SearchJumpInfo from '@/components/search/SearchJumpInfo'
import MarkdownViewer from '@/components/common/MarkdownViewer'

import { getSearch } from '@/core/api'
import link from '@/core/mixins/link'
export default {
  name: 'search',
  mixins: [dateFilter, link, textFilter],
  components: {
    SearchJumpInfo,
    MarkdownViewer
  },
  data() {
    return {
      listData: {
        data: [],
        keyword: '',
        total: 0, // 总数
        page: 1, // 第几页
        pageSize: 5, //每页条数
        pageCount: 0
      },
      keyWord: '',
      errorMsg: '请输入关键字',
      searchClick: false,
      type: 'history' // 一进页面显示第一个'历史概况'
    }
  },
  watch: {
    '$route.fullPath'() {
      this.initPageData()
    }
  },
  computed: {
    searchType() {
      return this.$store.state.default.searchType
    }
  },
  created: function() {
    this.enterFn()
  },
  mounted: function() {
    this.initPageData()
  },
  methods: {
    initPageData() {
      this.type = this.$route.params.type // 从地址栏拿栏目的ID
      this.keyWord = this.$route.query.keyWord // 从地址栏拿关键词
      let windowOpen = this.$route.query.windowOpen // 从地址栏拿是否开瓷器弹框

      this.getListData()
      if (windowOpen) {
        let modalData = JSON.parse(sessionStorage.getItem('ceramicModalData'))
        this.$refs.SearchJumpInfo.listClickFn(modalData)
      }
    },
    enterFn() {
      //键盘事件,搜索
      let that = this
      document.onkeydown = function() {
        let key = window.event.keyCode
        if (key === 13) {
          that.searchFn()
        }
      }
    },
    // 关键词搜索
    searchFn() {
      let _this = this
      this.searchClick = true
      let t = setTimeout(function() {
        _this.searchClick = false
        clearTimeout(t)
      }, 350)
      this.listData.page = 1
      this.getListData()
    },
    // 分页切换
    clickCallback(pageNum) {
      document.body.scrollIntoView()
      this.listData.page = pageNum
      this.getListData()
    },
    // tab栏切换
    tabFn(value) {
      this.type = value
      this.listData.page = 1
      this.getListData()
      this.link({
        type: 'link',
        link: '/search/' + value,
        query: {
          keyWord: this.keyWord
        }
      })
    },
    // 内容点击跳转
    listClickFn(data) {
      this.$refs.SearchJumpInfo.listClickFn(data, 'windowOpen')
    },
    async getListData() {
      if (!this.keyWord || this.keyWord.trim().length === 0) {
        this.errorMsg = '请输入关键字'
        this.listData.data = []
        return
      }
      let data = {
        page: this.listData.page,
        pageSize: this.listData.pageSize,
        keyword: this.keyWord,
        type: this.type
      }
      let res = await getSearch(data)
      // console.log(res) // eslint-disable-line no-console
      if (res.status === 200) {
        if (res.data.data.length === 0) {
          this.errorMsg = '暂无数据'
        }
        this.listData.keyword = this.keyWord
        this.listData.total = res.data.total
        this.listData.data = res.data.data
        this.listData.pageCount = Math.ceil(
          this.listData.total / this.listData.pageSize
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.search {
  min-height: 80vh;
  .search-input {
    height: 168px;
    padding-top: 60px;
    padding-bottom: 58px;
    padding-right: 80px;
    position: relative;
    ::-webkit-input-placeholder {
      /* WebKit browsers */
      font-style: 18px;
    }
    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      font-style: 18px;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      font-style: 18px;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10+ */
      font-style: 18px;
    }
    .input-css {
      width: 100%;
      height: 50px;
      padding: 0 80px 0 28px;
      border-right: 0 none;
      border-color: $c-list-light-border;
      color: $c-tour-0;
    }
    .search-btn {
      height: 50px;
      line-height: 50px;
      width: 80px;
      border: 1px solid $c-list-light-border;
      background-color: $c-list-bg;
      position: absolute;
      top: 60px;
      right: 0;
      .iconfont {
        font-size: 32px;
        margin-left: 22px;
      }
      &.active {
        border-color: $c-tour-2;
        color: $c-tour-2;
        transition: all 0.35s;
        -moz-transition: all 0.35s;
        /* Firefox 4 */
        -webkit-transition: all 0.35s;
        /* Safari 和 Chrome */
        -o-transition: all 0.35s;
        /* Opera */
      }
    }
  }
  .search-title {
    margin-bottom: 15px;
  }
  .search-title-list {
    cursor: pointer;
    padding: 0 42px;
    float: left;
    height: 100%;
    line-height: 26px;
    text-align: center;
    font-size: 18px;
    color: $c-tour-0;
    background-position: center;
    background-size: auto 0;
    background-repeat: no-repeat;
    &:hover {
      transition: all 0.35s;
      -moz-transition: all 0.35s; /* Firefox 4 */
      -webkit-transition: all 0.35s; /* Safari 和 Chrome */
      -o-transition: all 0.35s; /* Opera */
      color: $c-tour-2;
    }
    &.active {
      transition: all 0.35s;
      -moz-transition: all 0.35s; /* Firefox 4 */
      -webkit-transition: all 0.35s; /* Safari 和 Chrome */
      -o-transition: all 0.35s; /* Opera */
      color: $c-tour-2;
      background: url('../../../static/images/public/left-deep-active.png') 0 0,
        url('../../../static/images/public/right-deep-active.png') 100% 0;
      background-size: auto 26px;
      background-repeat: no-repeat;
    }
  }
  .image-text-lists-total {
    line-height: 1;
    padding-top: 28px;
    padding-bottom: 28px;
    font-size: 14px;
    color: $c-tour-0;
  }
  .image-text-lists {
    padding-top: 60px;
  }
  .image-text-content {
    &.no-img {
      padding-left: 34px;
      .image-text-content-title {
        line-height: 40px;
        margin-bottom: 40px;
      }
    }
  }
  .image-text-content-time {
    cursor: default;
  }
  .from {
    cursor: pointer;
    color: $c-orange;
    text-decoration: underline;
  }
  .pag {
    padding: 35px 0 78px 0;
  }
}
</style>
